import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';

const CountryLetterItem = (props) => {
    return (
        <Panel negativeMargin>
            <DiskBadge variant="letterIndex" diskText={props.letter} />
        </Panel>
    );
};

export default CountryLetterItem;
